// 组件全局注册
import Vue from 'vue';

//面包屑
import Breadcrumb from './breadcrumb/index.js'
Vue.use(Breadcrumb);



//圆环进度条绘制
import SHCircular from './charts/circular/index.js'
Vue.use(SHCircular);


//饼图或圆环图
import SHPie from './charts/pie/index.js'
Vue.use(SHPie);


//柱状图
import SHBar from './charts/bar/index.js'
Vue.use(SHBar);


//图片上传
import SHImgUpload from './upload/imgs/index.js'
Vue.use(SHImgUpload);

//用户登陆
import SHLogon from './logon/index.js'
Vue.use(SHLogon);


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/cmps.js